import { inject, injectable } from "inversify";
import { BudgetRepository } from "@project/data/repositories/budget.repository";

export interface CreateJustificationTemplateInput {
    name: string;
    description?: string;
    version: number;
    visible: boolean;
    json_schema: any;
    template_key: string;
}

@injectable()
export class CreateJustificationTemplateUseCase {
    constructor(
        @inject(BudgetRepository)
        private readonly budgetRepository: BudgetRepository,
    ) { }

    async execute(input: CreateJustificationTemplateInput): Promise<number | null> {
        return this.budgetRepository.createJustificationTemplate(input);
    }
}
